import Sidebar from './Sidebar';

const UserSidebar = () => {
  return <Sidebar role="user" />;
};

export default UserSidebar;